/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export { default as Tag } from './tag';
// Styled elements
export { Root as StyledRoot, Action as StyledAction, Text as StyledText } from './styled-components';
export { KIND, HIERARCHY, SIZE, SUPPORTED_KIND, DEPRECATED_KIND } from './constants';
export * from './types';